/**
 * Normaliza idempotencyReport para garantir sempre a mesma estrutura
 * Independente se vem de upload (com details) ou getStagingData
 */

export interface IdempotencyDetails {
  new: Array<{ rowNumber: number; status: 'NEW'; data: any; message?: string }>;
  skipped: Array<{ rowNumber: number; status: 'SKIPPED'; data: any; message?: string }>;
  conflicted: Array<{ rowNumber: number; status: 'CONFLICTED'; data: any; divergentFields?: string[]; message?: string }>;
}

/**
 * Normaliza qualquer formato de idempotencyReport para a estrutura padrão
 * 
 * Entrada pode ser:
 * 1. { newCount, skippedCount, conflictedCount, details: { new, skipped, conflicted } }
 * 2. { new, skipped, conflicted }
 * 3. undefined/null
 * 
 * Saída é sempre: { new: [], skipped: [], conflicted: [] }
 */
export function normalizeIdempotency(report: any): IdempotencyDetails {
  if (!report) {
    return {
      new: [],
      skipped: [],
      conflicted: [],
    };
  }

  // Se tem details, usar details (estrutura de upload)
  const details = report.details ?? report;

  return {
    new: Array.isArray(details.new) ? details.new : [],
    skipped: Array.isArray(details.skipped) ? details.skipped : [],
    conflicted: Array.isArray(details.conflicted) ? details.conflicted : [],
  };
}

/**
 * Extrai contadores normalizados
 */
export function getIdempotencyCounts(report: any) {
  const normalized = normalizeIdempotency(report);
  return {
    newCount: normalized.new.length,
    skippedCount: normalized.skipped.length,
    conflictedCount: normalized.conflicted.length,
  };
}
